module.exports = __webpack_public_path__ + "media/images/common/2column_product_bg_yy-89ce190ae66b7f7281812837b38dd65f.png";